import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c4df11f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "ant-row",
  style: {"font-size":"small"}
}
const _hoisted_2 = {
  class: "ant-col ant-col-xs-8 ant-col-xl-8",
  style: {"margin-left":"14px","margin-right":"-12px"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ant-divider ant-divider-horizontal",
  role: "separator",
  style: {"margin-top":"1px","margin-bottom":"1px"}
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_resultado_d_r_e = _resolveComponent("resultado-d-r-e", true)!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", null, _toDisplayString(_ctx.props.resultado.descricao), 1)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.resultado.valores, (valor, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "ant-col ss-coluna-resultado",
          key: index
        }, _toDisplayString((_ctx.props.tipoGrupo == 2 && valor > 0 ? '-' : '') + _ctx.UtilitarioMascara.mascararValor(valor, 2, false, true)), 1))
      }), 128))
    ]),
    (_ctx.UtilitarioGeral.validaLista(_ctx.props.resultado.itens))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_3,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.resultado.itens, (item, index) => {
            return (_openBlock(), _createBlock(_component_resultado_d_r_e, {
              "tipo-grupo": _ctx.props.tipoGrupo,
              key: index,
              resultado: item
            }, null, 8, ["tipo-grupo", "resultado"]))
          }), 128))
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}